// Import model
import { StartLeadSendOmwsmsRequest } from '../models/StartLeadSendOmwsmsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadSendOmwsmsRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadSendOmwsmsRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadSendOmwsmsRequest instance
   */
  static deserialize(json: string): StartLeadSendOmwsmsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadSendOmwsmsRequest instance
   */
  static fromObject(obj: any): StartLeadSendOmwsmsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadSendOmwsmsRequest');
    }


    const instance: StartLeadSendOmwsmsRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadSendOmwsmsRequest instances
   */
  static deserializeArray(json: string): StartLeadSendOmwsmsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadSendOmwsmsRequest instance to a JSON string
   */
  static serialize(instance: StartLeadSendOmwsmsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadSendOmwsmsRequest instance to a plain object
   */
  static toObject(instance: StartLeadSendOmwsmsRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartLeadSendOmwsmsRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadSendOmwsmsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
